import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router';
import { EventView as IEventView, RequestView as IRequestView } from '../../../../../../typings/View.interface';
import { formatPath } from '../../../utils/path';
import ErrorBoundary from '../../common/helpers/ErrorBoundary';
import ViewRoute from '../../common/ViewRoute';
import { DashboardLayout, DashboardLayoutContent } from '../../layouts/ViewLayout';
import BookmarksView from './Bookmarks';
import ConnectionsView from './Connections';
import ConnectionView from './Connections/Connection/ConnectionView';
import CreateConnectionView from './Connections/Create/CreateView';
import DestinationsView from './Connections/Destination/DestinationsView';
import DestinationView from './Connections/Destination/DestinationView';
import SourcesView from './Connections/Source/SourcesView';
import SourceView from './Connections/Source/SourceView';
import { DashboardContext } from './DashboardContext';
import EventView from './Event';
import EventsView from './Events';
import GetStartedView from './GetStarted';
import IssueView from './Issue';
import IssuesView from './Issues';
import IssueTriggersListView from './IssueTriggers';
import IssueTriggerView from './IssueTriggers/IssueTrigger/IssueTriggerView';
import MetricsView from './Metrics';
import DashboardNav from './Nav';
import RequestView from './Request';
import RequestsView from './Requests';
import Settings from './Settings';
import TeamMemberOverLimitModal from './TeamMemberOverLimitModal';
import TransformationView from './Transformation';
import TransformationsView from './Transformation/TransformationsView';
import { ViewsContextProvider } from './ViewsContext';
const EventGatewayScene: React.FC<{
  banner_active: boolean;
}> = t0 => {
  const $ = _c(37);
  const {
    banner_active
  } = t0;
  const location = useLocation();
  const {
    nav_collapsed
  } = useContext(DashboardContext);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DashboardNav />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TeamMemberOverLimitModal />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== location.pathname) {
    t3 = location.pathname.replace("/webhooks", "/connections");
    $[2] = location.pathname;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== location || $[5] !== t3) {
    t4 = <Redirect path="/webhooks" to={{
      ...location,
      pathname: t3
    }} />;
    $[4] = location;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Route path="/settings" component={Settings} />;
    t6 = <ViewRoute usePathAsTitle={true} path="/connections/new" component={CreateConnectionView} />;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ViewRoute usePathAsTitle={true} exact={true} path={["/sources", "/sources/new"]} component={SourcesView} />;
    t8 = <ViewRoute usePathAsTitle={true} path="/sources/:id" component={SourceView} />;
    $[9] = t7;
    $[10] = t8;
  } else {
    t7 = $[9];
    t8 = $[10];
  }
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ViewRoute usePathAsTitle={true} exact={true} path={["/destinations", "/destinations/new"]} component={DestinationsView} />;
    t10 = <ViewRoute usePathAsTitle={true} path="/destinations/:id" component={DestinationView} />;
    t11 = <ViewRoute usePathAsTitle={true} path="/connections/:id" component={ConnectionView} />;
    t12 = <ViewRoute usePathAsTitle={true} path="/connections" component={ConnectionsView} />;
    t13 = <Route path="/events" render={_temp3} />;
    t14 = <Route path="/requests" render={_temp6} />;
    t15 = <ViewRoute usePathAsTitle={true} path="/get-started" component={GetStartedView} />;
    t16 = <ViewRoute usePathAsTitle={true} path="/bookmarks" component={BookmarksView} />;
    $[11] = t10;
    $[12] = t11;
    $[13] = t12;
    $[14] = t13;
    $[15] = t14;
    $[16] = t15;
    $[17] = t16;
    $[18] = t9;
  } else {
    t10 = $[11];
    t11 = $[12];
    t12 = $[13];
    t13 = $[14];
    t14 = $[15];
    t15 = $[16];
    t16 = $[17];
    t9 = $[18];
  }
  let t17;
  let t18;
  let t19;
  let t20;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <ViewRoute usePathAsTitle={true} exact={true} path={["/transformations", "/transformations/new"]} component={TransformationsView} />;
    t18 = <ViewRoute usePathAsTitle={true} path="/transformations/:id*" component={TransformationView} />;
    t19 = <ViewRoute usePathAsTitle={true} path="/issues/:id" component={IssueView} />;
    t20 = <ViewRoute usePathAsTitle={true} exact={true} path="/issues" component={IssuesView} />;
    $[19] = t17;
    $[20] = t18;
    $[21] = t19;
    $[22] = t20;
  } else {
    t17 = $[19];
    t18 = $[20];
    t19 = $[21];
    t20 = $[22];
  }
  let t21;
  let t22;
  let t23;
  let t24;
  let t25;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <ViewRoute usePathAsTitle={true} exact={true} path={["/issue-triggers", "/issue-triggers/delivery", "/issue-triggers/transformation", "/issue-triggers/backpressure", "/issue-triggers/request", "/issue-triggers/:type/create/:createtype"]} component={IssueTriggersListView} />;
    t22 = <ViewRoute usePathAsTitle={true} path="/issue-triggers/:id" component={IssueTriggerView} />;
    t23 = <ViewRoute usePathAsTitle={true} path="/metrics/:category" component={MetricsView} />;
    t24 = <ViewRoute usePathAsTitle={true} path="/metrics" component={MetricsView} />;
    t25 = <Redirect to="/events" />;
    $[23] = t21;
    $[24] = t22;
    $[25] = t23;
    $[26] = t24;
    $[27] = t25;
  } else {
    t21 = $[23];
    t22 = $[24];
    t23 = $[25];
    t24 = $[26];
    t25 = $[27];
  }
  let t26;
  if ($[28] !== t4) {
    t26 = <ErrorBoundary>{t2}<Switch>{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}{t21}{t22}{t23}{t24}{t25}</Switch></ErrorBoundary>;
    $[28] = t4;
    $[29] = t26;
  } else {
    t26 = $[29];
  }
  let t27;
  if ($[30] !== banner_active || $[31] !== t26) {
    t27 = <DashboardLayoutContent id="main" banner_active={banner_active}>{t26}</DashboardLayoutContent>;
    $[30] = banner_active;
    $[31] = t26;
    $[32] = t27;
  } else {
    t27 = $[32];
  }
  let t28;
  if ($[33] !== banner_active || $[34] !== nav_collapsed || $[35] !== t27) {
    t28 = <DashboardLayout nav_collapsed={nav_collapsed} banner_active={banner_active}>{t1}{t27}</DashboardLayout>;
    $[33] = banner_active;
    $[34] = nav_collapsed;
    $[35] = t27;
    $[36] = t28;
  } else {
    t28 = $[36];
  }
  return t28;
};
export default EventGatewayScene;
function _temp(view) {
  return <ViewRoute title="Events" subtitle={view.name} key={view.id} path={[`/events/${formatPath(view.name)}`, `/cli/events/${formatPath(view.name)}`]}><EventsView current_view={view as IEventView} /></ViewRoute>;
}
function _temp2(t0) {
  const {
    views
  } = t0;
  return views && <Switch>{views.models.map(_temp)}<ViewRoute usePathAsTitle={true} path={["/events/:id", "/cli/events/:id"]} component={EventView} /><ViewRoute usePathAsTitle={true} path={["/events"]}><EventsView /></ViewRoute></Switch>;
}
function _temp3() {
  return <ViewsContextProvider type="events" redirect_root="/events">{_temp2}</ViewsContextProvider>;
}
function _temp4(view_0) {
  return <ViewRoute title="Requests" subtitle={view_0.name} key={view_0.id} path={[`/requests/${formatPath(view_0.name)}`, `/cli/requests/${formatPath(view_0.name)}`]}><RequestsView current_view={view_0 as IRequestView} /></ViewRoute>;
}
function _temp5(t0) {
  const {
    views: views_0
  } = t0;
  return views_0 && <Switch>{views_0.models.map(_temp4)}<ViewRoute usePathAsTitle={true} path={["/requests/:id", "/cli/requests/:id"]} component={RequestView} /><ViewRoute usePathAsTitle={true} path="/requests"><RequestsView /></ViewRoute></Switch>;
}
function _temp6() {
  return <ViewsContextProvider type="requests" redirect_root="/requests">{_temp5}</ViewsContextProvider>;
}